import React from 'react';
import './ProfilePickerTrigger.less';

export const ProfilePickerTrigger = ({text}) => {
	return <span className="profile-picker-trigger">{text}</span>
}
